/* eslint-disable react-hooks/exhaustive-deps */
import {RootState, useAppDispatch, useAppSelector} from "../../../../state/state.tsx";
import besakshamLogo from "../../../../assets/HosakshamHorizontal.png"
import OTPForm from "./Components/Otplogin.tsx";
import PhoneLogin from "./Components/PhoneLogin.tsx";
import {useEffect, useState} from "react";
import {auth, db, SECRETS_ENV} from "../../../../Config/firebase.ts";
import {RecaptchaVerifier, signInWithPhoneNumber} from "firebase/auth";
import { actions as userV2Actions } from "../../../../state/UserStatesV2/userSliceV2.ts";
import {useNavigate} from "react-router-dom";
import {collection, getDocs, query, where} from "firebase/firestore";
import PageNotFound from "../ErrorPages/PageNotFound.tsx";
import loginPageImage from "../../../../assets/images/login-pageImage-new.png"
import { UserStateV2 } from "../../types/UserStateV2.ts";

// TypeScript declaration for window.recaptchaVerifier
declare global {
    interface Window {
        recaptchaVerifier: RecaptchaVerifier | null;
    }
}

export default function Login() {

    const Dispatch = useAppDispatch();
    const userSlice = useAppSelector((state: RootState) => state.userSliceV2)   
    const authState = (userSlice.data as UserStateV2)?.isAuthenticated
    const loading = userSlice.data?.loading

    const [phoneNumber, setPhoneNumberState] = useState<string>("")
    const [isPhoneNumberSubmitted, setIsPhoneNumberSubmitted] = useState<boolean>(false)
    const [OtpConfirmationResult, setOtpConfirmationResult] = useState<any>()
    const [InvalidOtpError, setInvalidOtpError] = useState<boolean>(false)
    const navigate = useNavigate();
    const [otpFormReady, setOtpFormReady] = useState(false);
    const [subDomain, setSubDomain] = useState<string>("")
    const [customBrandingImage, setCustomBrandingImage] = useState<string>("")
    const [customLogo, setCustomLogo] = useState<string>("")
    const [isSubDomainError, setIsSubDomainError] = useState<boolean>(false)
    const [isOtpSubmitLoading, setIsOtpSubmitLoading] = useState<boolean>(false)
    const [showManualCaptcha, setShowManualCaptcha] = useState<boolean>(false)
    const [captchaError, setCaptchaError] = useState<string>("")

    // Check if user is available and retrieve information from firestore
    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged(user => {
             
            if (user) {
            
                Dispatch(userV2Actions.setPhoneNumber(user.phoneNumber!))
       
                Dispatch(userV2Actions.setOtherDetails({ uid: user.uid }));
           
                Dispatch(userV2Actions.checkUserInFirestore(user.uid));

                Dispatch(userV2Actions.setAuthenticated(true));

            }
           
        });

        return () => unsubscribe();
    }, [Dispatch]);

    // Cleanup reCAPTCHA when component unmounts
    useEffect(() => {
        return () => {
            cleanupRecaptcha();
        };
    }, []);

    // Checking for auth status followed by required navigation

    useEffect(() => {
       if(loading){
        return
       }
        if (authState === true && (userSlice.data as UserStateV2)?.display_name) {
            // Clean up reCAPTCHA before navigation
            cleanupRecaptcha();
            navigate("/mydashboard")
        } else if (authState === true) {
            // Clean up reCAPTCHA before navigation
            cleanupRecaptcha();
            navigate("/fill-details")
        }
    }, [authState, navigate, userSlice,loading])

    // Function to clean up reCAPTCHA elements
    const cleanupRecaptcha = () => {
        try {
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }
            
            const recaptchaContainer = document.getElementById('recaptcha-container');
            if (recaptchaContainer) {
                recaptchaContainer.innerHTML = '';
            }
            
            console.log('reCAPTCHA cleanup completed');
        } catch (error) {
            console.warn('Error during reCAPTCHA cleanup:', error);
        }
    };

    async function setupRecaptcha(auth: any, useVisible: boolean = false): Promise<void> {
        try {
            // Only setup if not already initialized or if switching to visible mode
            if (window.recaptchaVerifier && !useVisible) {
                console.log('reCAPTCHA already initialized, reusing existing instance');
                return;
            }

            // Clear any existing verifier
            if (window.recaptchaVerifier) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }

            // Dynamically load reCAPTCHA script only when needed
            if (!document.querySelector('script[src*="recaptcha"]')) {
                console.log('Loading reCAPTCHA script dynamically');
                const script = document.createElement('script');
                script.src = 'https://www.google.com/recaptcha/enterprise.js?render=6LfXGFMrAAAAAGznV6Uj5yhy-VX7RIKbX4g21QKm';
                script.async = true;
                script.defer = true;
                
                // Wait for script to load before proceeding
                await new Promise((resolve, reject) => {
                    script.onload = resolve;
                    script.onerror = reject;
                    document.head.appendChild(script);
                });
            }

            const { RecaptchaVerifier } = await import('firebase/auth');
            
            if (useVisible) {
                // Manual/visible captcha for fallback
                window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                    size: 'normal',
                    callback: () => {
                        console.log('Manual reCAPTCHA completed');
                        setCaptchaError("");
                    },
                    'expired-callback': () => {
                        setCaptchaError("reCAPTCHA expired. Please try again.");
                    }
                });
            } else {
                // Invisible captcha with Enterprise + App Check
                window.recaptchaVerifier = new RecaptchaVerifier(auth, 'recaptcha-container', {
                    size: 'invisible',
                });
            }
            
            console.log('reCAPTCHA initialized successfully');
        } catch (error) {
            console.error("Error setting up reCAPTCHA:", error);
            throw error;
        }
    }

    async function sendOtp(auth: any, phoneNumber: string, retryWithManual: boolean = false): Promise<void> {
        try {
            console.log(`Sending OTP to ${phoneNumber} (retryWithManual: ${retryWithManual})`);
            
            // LAZY INITIALIZATION: Only setup reCAPTCHA when actually sending OTP
            if (!window.recaptchaVerifier || retryWithManual) {
                await setupRecaptcha(auth, retryWithManual);
                if (retryWithManual) {
                    setShowManualCaptcha(true);
                    setCaptchaError("Please complete the security verification below to continue.");
                }
            }
            
            const sendingPhoneNumber: string = "+91" + phoneNumber;
            const confirmation = await signInWithPhoneNumber(auth, sendingPhoneNumber, window.recaptchaVerifier!);
            setOtpConfirmationResult(confirmation);
            
            // Success - hide manual captcha if it was shown
            setShowManualCaptcha(false);
            setCaptchaError("");
            
            console.log('OTP sent successfully');
            
        } catch (err: any) {
            console.error("Error sending OTP:", err);
            console.error("Error code:", err.code);
            console.error("Error message:", err.message);
            
            // Enhanced error handling for various failure scenarios
            const isAppCheckError = err.message?.includes('AppCheck') || 
                                   err.message?.includes('app-check') ||
                                   err.message?.includes('recaptcha-error') ||
                                   err.code === 'auth/app-check-token-invalid';
                                   
            const isCaptchaError = err.code === 'auth/captcha-check-failed' || 
                                  err.code === 'auth/too-many-requests' ||
                                  err.code === 'auth/invalid-app-credential' ||
                                  err.code === 'auth/unauthorized-domain' ||
                                  err.message?.includes('reCAPTCHA') ||
                                  err.message?.includes('401');
            
            if ((isAppCheckError || isCaptchaError) && !retryWithManual) {
                // First failure - try with manual captcha
                console.log("reCAPTCHA/AppCheck failed, falling back to manual captcha");
                setCaptchaError("Security verification failed. Please complete the security check below.");
                setShowManualCaptcha(true);
                return await sendOtp(auth, phoneNumber, true);
            } else if ((isAppCheckError || isCaptchaError) && retryWithManual) {
                // Manual captcha also failed
                setCaptchaError("Security verification failed. Please ensure you completed the captcha correctly and try again.");
                setShowManualCaptcha(true); // Keep it visible for retry
            } else if (err.code === 'auth/invalid-phone-number') {
                setCaptchaError("Invalid phone number. Please check and try again.");
                setShowManualCaptcha(false);
            } else if (err.code === 'auth/too-many-requests') {
                setCaptchaError("Too many attempts. Please wait a few minutes before trying again.");
                setShowManualCaptcha(false);
            } else {
                // Other errors
                setCaptchaError("Unable to send OTP. Please check your connection and try again.");
                setShowManualCaptcha(false);
            }
            
            // Clean up on error, but preserve manual captcha if needed
            if (window.recaptchaVerifier && !showManualCaptcha) {
                window.recaptchaVerifier.clear();
                window.recaptchaVerifier = null;
            }
            
            throw err;
        }
    }

    async function onSubmitPhoneNumber(): Promise<void> {
        try {
            console.log("onSubmitPhoneNumber", phoneNumber);
            console.log("Browser:", navigator.userAgent);
            
            await sendOtp(auth, phoneNumber);
            setOtpFormReady(true);
        } catch (error) {
            console.error("Error in phone number submission:", error);
            setCaptchaError("Unable to send OTP. Please check your connection and try again.");
        }
    }


    async function onVerifyOTP(OTP: string): Promise<void> {
        try {
            console.log("onVerifyOTP", OTP);
            console.log("Browser:", navigator.userAgent);
            
            setIsOtpSubmitLoading(true); // Start loading
            if (OtpConfirmationResult) {
                console.log("OtpConfirmationResult", OtpConfirmationResult);
                
                const result = await OtpConfirmationResult.confirm(OTP);
                console.log("OTP verification result:", result);
                
                // The onAuthStateChanged listener will handle the state updates
            } else {
                throw new Error("No OTP confirmation result available");
            }
        } catch (error: any) {
            console.error("OTP verification error:", error);
            console.error("Error code:", error.code);
            console.error("Error message:", error.message);
            
            // Handle specific error cases
            if (error.code === 'auth/invalid-verification-code') {
                setInvalidOtpError(true);
                setCaptchaError("Invalid OTP. Please check and try again.");
            } else if (error.code === 'auth/invalid-verification-id') {
                setInvalidOtpError(true);
                setCaptchaError("OTP session expired. Please request a new OTP.");
            } else if (error.code === 'auth/code-expired') {
                setInvalidOtpError(true);
                setCaptchaError("OTP has expired. Please request a new OTP.");
            } else {
                setInvalidOtpError(true);
                setCaptchaError("OTP verification failed. Please try again.");
            }
        } finally {
            setIsOtpSubmitLoading(false); // Stop loading
        }
    }


    // function onChangeOtpSubmitLoading(value:boolean){
    //     setIsOtpSubmitLoading(value)
    // }

    // ---------------- Subdomain config


    useEffect(() => {
        const host = window.location.host;
        const arr = host.split(".")
        

        if (arr.length > 0) {
            // Check if the first part is 'www' and take the next part as subdomain
            const potentialSubDomain = arr[0] === 'www' ? arr[1] : arr[0];
            if (potentialSubDomain.includes("localhost")) {
                return;
            }
            
            if (potentialSubDomain && !SECRETS_ENV.EXCLUDED_DOMAINS.includes(potentialSubDomain)) {
                setSubDomain(potentialSubDomain);
            }
        }
    }, []);

    useEffect(() => {
        if (subDomain) {
            retreiveDocsForSubdomain()
        }
    }, [retreiveDocsForSubdomain, subDomain]);


    async function retreiveDocsForSubdomain() {
        const subdomainQuery = query(collection(db, 'CustomBranding'), where('subdomain', '==', `${subDomain}.${SECRETS_ENV.DOMAIN}`));
        const querySnapshot = await getDocs(subdomainQuery);
        if (!querySnapshot.empty) {
            const firstDoc = querySnapshot.docs[0];
            const brandingImage = firstDoc.data().brandingImage;
            const customlogos = firstDoc.data().logo
            setCustomBrandingImage(brandingImage)
            setCustomLogo(customlogos)
        } else {
            setIsSubDomainError(true)
        }
    }

    // Add body class for login page and global reCAPTCHA cleanup
    useEffect(() => {
        document.body.classList.add('login-page');
        
        // Add global styles to hide reCAPTCHA badge everywhere
        const globalStyle = document.createElement('style');
        globalStyle.id = 'recaptcha-global-hide';
        globalStyle.textContent = `
            /* Hide reCAPTCHA badge globally by default - preserve functionality */
            .grecaptcha-badge { 
                visibility: hidden !important;
                opacity: 0 !important;
                position: fixed !important;
                bottom: -100px !important;
                right: -100px !important;
                z-index: -999999 !important;
                pointer-events: none !important;
            }
            
            /* Only show reCAPTCHA on login page when manual captcha is needed */
            body.login-page .grecaptcha-badge.manual-captcha-visible { 
                visibility: visible !important;
                opacity: 1 !important;
                bottom: 14px !important;
                right: 14px !important;
                z-index: 9999 !important;
                pointer-events: auto !important;
            }
        `;
        document.head.appendChild(globalStyle);
        
        return () => {
            document.body.classList.remove('login-page');
            // Remove global styles when leaving login
            const existingStyle = document.getElementById('recaptcha-global-hide');
            if (existingStyle) {
                existingStyle.remove();
            }
            // Only cleanup on navigation, not during active auth
            setTimeout(() => {
                cleanupRecaptcha();
            }, 1000);
        };
    }, []);

    if (isSubDomainError) {
        return <PageNotFound/>
    }

    return (
        <div className="login-container h-[100vh] max-h-[100vh] overflow-hidden w-[100vw] bg-white">
            {/* CSS to hide reCAPTCHA badge */}
            <style>{`
                /* Hide reCAPTCHA badge by default */
                .grecaptcha-badge { 
                    visibility: hidden !important;
                }
                
                /* Show reCAPTCHA badge when manual captcha is active */
                ${showManualCaptcha ? `
                    .grecaptcha-badge { 
                        visibility: visible !important;
                        position: fixed !important;
                        bottom: 14px !important;
                        right: 14px !important;
                        z-index: 9999 !important;
                    }
                    
                    /* Ensure manual captcha container is visible */
                    #recaptcha-container {
                        display: block !important;
                        visibility: visible !important;
                        opacity: 1 !important;
                        margin: 10px 0 !important;
                        min-height: 78px !important;
                    }
                ` : `
                    /* Ensure container is hidden when not in manual mode */
                    #recaptcha-container {
                        display: none !important;
                    }
                `}
            `}</style>
            <div className="h-full w-full flex">
                {/* Left Side - Promotional Image */}
                <div className="hidden lg:block w-1/2 h-full">
                    <img 
                        alt="Promotional" 
                        className="w-full h-full object-cover" 
                        src={customBrandingImage || loginPageImage}
                    />
                </div>

                {/* Right Side - Login Form */}
                <div className="w-full lg:w-1/2 flex items-center lg:justify-start lg:pl-16 p-8">
                    <div className="w-full max-w-md">
                        <div className="flex flex-col items-center">
                            {/* Mobile-only image */}
                            <img 
                                alt="Promotional" 
                                className="lg:hidden w-full h-auto max-h-[200px] object-cover rounded-xl shadow-md mb-8" 
                                src={customBrandingImage || loginPageImage}
                            />

                            <div className="w-full bg-white rounded-2xl shadow-lg p-5">
                                <div className="flex justify-center mb-1">
                                    <img 
                                        className="h-14 lg:h-20" 
                                        src={customLogo || besakshamLogo} 
                                        alt="Logo" 
                                    />
                                </div>
                                
                                {isPhoneNumberSubmitted ? (
                                    <OTPForm 
                                        phoneNumber={phoneNumber} 
                                        onVerifyOTP={onVerifyOTP}
                                        setIsPhoneNumberSubmitted={setIsPhoneNumberSubmitted}
                                        setInvalidOtpError={setInvalidOtpError}
                                        InvalidOtpError={InvalidOtpError}
                                        onSubmitPhoneNumber={onSubmitPhoneNumber} 
                                        otpFormReady={otpFormReady}
                                        isOtpSubmitLoading={isOtpSubmitLoading}
                                    />
                                ) : (
                                    <PhoneLogin 
                                        onSubmitPhoneNumber={onSubmitPhoneNumber} 
                                        phoneNumber={phoneNumber}
                                        setPhoneNumberState={setPhoneNumberState}
                                        setIsPhoneNumberSubmitted={setIsPhoneNumberSubmitted}
                                    />
                                )}
                                {/* reCAPTCHA container - hidden by default, visible when manual captcha is needed */}
                                <div id="recaptcha-container" style={{ display: showManualCaptcha ? 'block' : 'none' }}></div>
                                
                                {/* Manual captcha indicator */}
                                {showManualCaptcha && (
                                    <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                                        <div className="flex items-center">
                                            <div className="w-2 h-2 bg-blue-500 rounded-full mr-2 animate-pulse"></div>
                                            <p className="text-sm text-blue-800 font-medium">
                                                Security Verification Required
                                            </p>
                                        </div>
                                        <p className="text-xs text-blue-600 mt-1">
                                            Please complete the security check above to proceed.
                                        </p>
                                    </div>
                                )}
                                
                                {/* Show captcha error message */}
                                {captchaError && (
                                    <div className="mt-2 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                                        <p className="text-sm text-orange-800">{captchaError}</p>
                                        {showManualCaptcha && (
                                            <p className="text-xs text-orange-600 mt-1">
                                                Complete the verification above, then try submitting your phone number again.
                                            </p>
                                        )}
                                    </div>
                                )}
                                <div className="mt-4 text-center text-sm text-gray-600">
                                    <a href="https://www.hosaksham.com/privacy-policy" className="text-blue-600 underline mr-1">Privacy Policy</a>| 
                                    <a href="https://www.hosaksham.com/terms-and-conditions" className="text-blue-600 underline ml-1">Terms & Conditions</a>
                                </div>
                                <div className="mt-2 text-center text-sm text-gray-600">Discover more about us at <a href="https://www.hosaksham.com" className="text-blue-600 underline">Hosaksham.com</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="absolute bottom-4 right-4 text-xs text-gray-500">
                <p>© {new Date().getFullYear()} EagleX SaS Makers Private Limited | All Rights Reserved</p>
                
            </div>
        </div>
    )
}
